module.exports = __webpack_public_path__ + "img/businesLicese2.a4208206.png";